import React, {useEffect,useState} from 'react';
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import loader from '../../assests/loader.gif';
import Appqr from '../../components/Appqr';
import { Link } from "react-router-dom";
import "./Contact.css";
import {validatecontact} from '../../Utils/validate';
import API from '../../Utils/Api';
import { gettoastsuccess,gettoastwarning } from '../../Utils/Common';

const Contact = () => {
	const [loading,setLoading] = useState(false);
	const [inputs,setInputs] = useState({first_name:'',last_name:'',email:'',message:'',subscribe:0});
	
	//const [inputsnew,setInputsnew] = useState({email:''});
	
	const [errors,setErrors] = useState({});
	//const [errorsnew,setErrorsnew] = useState({});
	
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
      });
    document.title = `Contact Us | Your Friend, My Friend`;
    document.getElementById('bodywrap').className='contact';
	
    const metaDesc = document.querySelector("meta[name='description']");
      if (metaDesc) {
        metaDesc.setAttribute("content", "Get in touch with the YFMF team. We’re here to help with event bookings, app support, sponsorships and media enquiries.");
      }

	window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
      });
	
  },[]);


/* Start Submit */
const handleSubmit = (event) => {
	event.preventDefault();
	const validationErrors = validatecontact(inputs);
	const noErrors = Object.keys(validationErrors).length === 0;
	setErrors({});
	setErrors(validationErrors);
		if(noErrors){
			setLoading(true);
			let formData = new FormData(); 
			formData.append('first_name', inputs.first_name);
			formData.append('last_name', inputs.last_name);
			formData.append('email', inputs.email);
			formData.append('message', inputs.message);
			API.post('contact', formData)
				.then(response => {
					setLoading(false);
				if(response.data.status === false){
					gettoastwarning(response.data.message,'/contact');
				}else{
				   gettoastsuccess(response.data.message,'/contact');
				}                  
			}).catch(error => {
				 
			});  
		}
}

/* Start Value set */
const handleInputChange = (event) => {
      event.persist();
      setInputs(inputs => ({...inputs, [event.target.name]: event.target.value})); 
}
/* start check subscribe */
const handleCheckboxChange = (event) => {
	 var subscribe_lbl='subscribe';
     setInputs(inputs => ({...inputs, [subscribe_lbl]: event.target.checked}));
 }
/* end check subscribe */
/* Start Value set */
/*const handleInputChangeNew = (event) => {
      event.persist();
      setInputsnew(inputsnew => ({...inputsnew, [event.target.name]: event.target.value})); 
}*/
/* Start Submit */
/*const handleSubmitNew = () => {
	const validationErrors = validatnew(inputsnew);
    const noErrors = Object.keys(validationErrors).length === 0;
	setErrorsnew({});
     setErrorsnew(validationErrors);
	 if(noErrors){
		setLoading(true);
		 let formData = new FormData(); 
			formData.append('email', inputsnew.email);
			API.post('newsletter', formData)
                .then(response => {
                if(response.data.status === false){
					gettoastwarning(response.data.message,'');
                    setLoading(false); 
                }else{
					setLoading(false); 
					setInputsnew({email:''});
				   gettoastsuccess(response.data.message,'');
                }                  
            }).catch(error => {
                 setLoading(false);
				 gettoastwarning('Something went wrong. Please try again later.','');
			});
	 }
}*/


  return (
    <>
    <Header />
      <div className="hello-worldss d-flex justify-content-center align-items-center">
        {/* Desktop Image */}
        <img
          src={process.env.REACT_APP_BASE_URL + 'assests/images/contact-new.jpg'}
          alt=""
          className="img-fluid"
        />
      </div>

      <div className="container-fluid message">
        {/* Contact Section */}
        <div className="row">
          <div className="col-md-6">
            <h2>Let’s connect!</h2>
            <div className="d-flex align-items-center gap-3 mb-4">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/form-butt-1.svg'}
                alt="Message Icon"
                className="img-fluid"
              />
              <div className="right-side">
                <h4>Send us a message</h4>
                <h5>
                  <a href="mailto:hello@yourfriendmyfriend.ie" style={{ textDecoration: "none", color: "inherit" }}>
                    hello@yourfriendmyfriend.ie
                  </a>
                </h5>
              </div>
            </div>

            <div className="d-flex align-items-center gap-3 mb-4">
              <a href="https://www.instagram.com/yourfriendmyfriend.ie" target="_blank" rel="noopener noreferrer" className="d-flex align-items-center gap-3 text-decoration-none">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/form-butt-2.svg'}
                alt="instagram"
                className="img-fluid"
              />
              <div className="right-side">
                <h4>Drop us a DM</h4>
                <h5>@yourfriendmyfriend.ie</h5>
              </div>
              </a>
            </div>

            <div className="d-flex align-items-center gap-3 mb-4">
              <a href="https://www.tiktok.com/@yourfriendmyfriend.ie" target="_blank" rel="noopener noreferrer" className="d-flex align-items-center gap-3 text-decoration-none">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/form-butt-3.svg'}
                alt="tiktok"
                className="img-fluid"
              />
              <div className="right-side">
                <h4>Follow us</h4>
                <h5>@yourfriendmyfriend.ie</h5>
              </div>
              </a>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card p-4">
              <form className="corencact" method="post" onSubmit={handleSubmit} enctype="multipart/form-data">
                <div className="row">
                  <div className="col-md-6">
                    <label htmlFor="first-name" className="form-label">
                      First name *
                    </label>
					
                    <input
                      type="text"
                      id="first-name"
					  className={`form-control mb-3 ${errors.first_name ? 'error' : ''}`}
                      placeholder="First Name"
					  name="first_name"
					  value={inputs.first_name}
					  onChange={handleInputChange}
                    />
					{(() => {
						if (Object.keys(errors).length > 0) {
							if(!errors.first_name)
							{
							return(<div className="w-100 position-relative">
                      <span className="fill-icon">
                        <img src={process.env.REACT_APP_BASE_URL + 'assests/images/fill.svg'} alt="Error" />
                      </span>
                    </div>)
							}
						}															
						  })()}
						  {errors.first_name && (<div className="w-100 position-relative">
							<span className="error-icon">
							  <img src={process.env.REACT_APP_BASE_URL + 'assests/images/error.svg'} alt="Error" />
							</span>
						  </div>)}
			
					{errors.first_name && (<p className="text-danger">{errors.first_name}</p>)}
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="last-name" className="form-label">
                      Last Name *
                    </label>
                    <input
                      type="text"
                      id="last-name"
                      className={`form-control mb-3 ${errors.last_name ? 'error' : ''}`}
                      placeholder="Last Name"
					  name="last_name"
					  value={inputs.last_name}
					  onChange={handleInputChange}
                    />
                    {(() => {
						if (Object.keys(errors).length > 0) {
							if(!errors.last_name)
							{
							return(<div className="w-100 position-relative">
                      <span className="fill-icon">
                        <img src={process.env.REACT_APP_BASE_URL + 'assests/images/fill.svg'} alt="Error" />
                      </span>
                    </div>)
							}
						}															
						  })()}
						  {errors.last_name && (<div className="w-100 position-relative">
							<span className="error-icon">
							  <img src={process.env.REACT_APP_BASE_URL + 'assests/images/error.svg'} alt="Error" />
							</span>
						  </div>)}
					{errors.last_name && (<p className="text-danger">{errors.last_name}</p>)}
                  </div>
                </div>

                <div className="col-md-12">
                  <label htmlFor="email" className="form-label">
                    Email *
                  </label>
                  <input
                    type="text"
                    id="email"
                    className={`form-control mb-3 ${errors.email ? 'error' : ''}`}
                    placeholder="Email"
					name="email"
					value={inputs.email}
					onChange={handleInputChange}
                  />
				  {(() => {
						if (Object.keys(errors).length > 0) {
							if(!errors.email)
							{
							return(<div className="w-100 position-relative">
                      <span className="fill-icon">
                        <img src={process.env.REACT_APP_BASE_URL + 'assests/images/fill.svg'} alt="Error" />
                      </span>
                    </div>)
							}
						}															
						  })()}
                  {errors.email && (<div className="w-100 position-relative">
                    <span className="error-icon">
                      <img src={process.env.REACT_APP_BASE_URL + 'assests/images/error.svg'} alt="Error" />
                    </span>
                  </div>)}
				  {errors.email && (<p className="text-danger">{errors.email}</p>)}
                </div>

                <div className="col-md-12">
                  <label htmlFor="message" className="form-label">
                    Your message *
                  </label>
                  <textarea
                    id="message"
					className={`form-control mb-3 h-100 ${errors.message ? 'error' : ''}`}
                    placeholder="Your message"
                    rows={1}
					name="message"
					value={inputs.message}
					onChange={handleInputChange}
                  ></textarea>
				  {(() => {
						if (Object.keys(errors).length > 0) {
							if(!errors.message)
							{
							return(<div className="w-100 position-relative">
								  <span className="fill-icon">
									<img src={process.env.REACT_APP_BASE_URL + 'assests/images/fill.svg'} alt="Error" />
								  </span>
								</div>)
							}
						}															
				  })()}
				  {errors.message && (<div className="w-100 position-relative">
					<span className="error-icon">
					  <img src={process.env.REACT_APP_BASE_URL + 'assests/images/error.svg'} alt="Error" />
					</span>
				  </div>)}
				  {errors.message && (<p className="text-danger">{errors.message}</p>)}
                </div>

                <div className="col-md-12">
                  <div className="form-check mb-3 d-flex align-items-center">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="subscribe"
                      name="subscribe"
					  value="1" checked={inputs.subscribe} onChange={handleCheckboxChange}
                    />
                    <label className="form-check-label" htmlFor="subscribe">
                      Sign me up for the latest YFMF news and upcoming events.
                    </label>
                  </div>
				  {errors.subscribe && (<p className="text-danger">{errors.subscribe}</p>)}
                </div>

                <div className="col-md-12">
                  <label className="mb-4">* Required fields</label>
                </div>

                <button className="btn" type="submit">
                  SEND MESSAGE
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid single-events together pt-0">
        <div className="row d-flex align-items-strech g-4">
          {/* Text Section */}
          <div className="col-md-4 d-flex">
            <div className="get-app d-flex flex-column align-items-start justify-content-center w-100">
              <h2>PARTNERSHIP</h2>
              <h3 className="text-start">Interested in a brand collab or hosting a YFMF event at your venue?</h3>
              <p className="text-start">
              We are always looking to collaborate and partner with new venues and brands so we can provide our attendees with the best possible experience. Let’s start the conversation!
              </p>
              {/*<div className="d-flex mb-3 w-100">
                <div className="subscribe-box">
                  <input
                    type="text"
					name="email" value={inputsnew.email} 
                    placeholder="Your email address"
                    className="form-control bg-transparent border-0"
					onChange={handleInputChangeNew}
                  />
                </div>
                <button className="btn px-3" type="button" onClick={handleSubmitNew}>
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/another-right.svg'}
                    alt="arrow"
                    className="img-fluid"
                  />
                </button>
				
              </div>
			  {errorsnew.email && (<p className="text-danger mt-2 text-inherit-news">{errorsnew.email}</p>)}*/}
              <div className="ireland p-0">
                <div className="ire-right">
               <div className="arrive mt-0 mb-3">
                <Link
                  to="mailto:hello@yourfriendmyfriend.ie"
                  className="btn bros-bu text-decoration-none"
                >
                  GET IN TOUCH
                </Link>
              </div>
            </div>
              <p className="text-start">*We respect your privacy and will never share your details.</p>
            </div>
            </div>
          </div>

          {/* Image Section */}
          <div className="col-md-8 d-flex">
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/con-bottom.png'}
              alt="Event Promo"
              className="img-fluid eve-img"
            />
          </div>
        </div>
      </div>
	    <Appqr />
      <Footer />
	  {loading && (
	   <div className="loadingClass">
			<img src={loader} alt="loader"/>
		</div>
	   )} 
    </>
  );
};

export default Contact;
